import React from "react";
import { Container, Typography, Button, CircularProgress } from "@material-ui/core";
import { orange, green, red } from "@material-ui/core/colors";
import AlertDiv from "../Components/Registration/Forms/AlertDiv";
import { GetData } from "../api/service";
import queryString from "query-string";

/**
 * Landing page after the gateway callback redirect for a payment request.
 * Route: /paymentresponse-request?status=..&message=..&token=..
 * Self-contained; does not modify any existing component.
 */
export default function PaymentResponseRequest(props) {
  const search = queryString.parse(props.history.location.search);
  const token = search.token || "";
  const status = search.status || "";
  const messageText = search.message || "";

  const [summary, setSummary] = React.useState(null);
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    if (token) {
      GetData(`/paymentrequest/view/${token}`).then((resp) => {
        if (resp && resp.status === true) {
          setSummary(resp);
        }
        setIsLoaded(true);
      });
    } else {
      setIsLoaded(true);
    }
    // eslint-disable-next-line
  }, []);

  const isSuccess = status === "Success" && summary && summary.payment_status === "PAID";

  return (
    <div>
      <Container>
        <br />
        <br />
        <h1>Payment Response</h1>

        {status !== "" && (
          <AlertDiv
            back={(isSuccess ? green : status === "Success" ? orange : red)[100]}
            border={(isSuccess ? green : status === "Success" ? orange : red)[400]}
          >
            <Typography variant="body2">
              {status} : {messageText}
            </Typography>
          </AlertDiv>
        )}

        {!isLoaded && (
          <div style={{ textAlign: "center", padding: 30 }}>
            <CircularProgress />
          </div>
        )}

        {isLoaded && isSuccess && (
          <div id="receipt-print" style={{ maxWidth: 600, margin: "20px auto", border: "1px solid #ccc", padding: 24 }}>
            <div style={{ textAlign: "center", marginBottom: 12 }}>
              <Typography variant="h6" style={{ fontWeight: 700 }}>
                Pragjyotish College
              </Typography>
              <Typography variant="body2">Online Fees Payment Receipt</Typography>
            </div>
            <hr />
            <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 12 }}>
              <tbody>
                <tr>
                  <td style={{ padding: "4px 8px", fontWeight: 700 }}>Receipt No</td>
                  <td style={{ padding: "4px 8px" }}>{summary.receipt_no}</td>
                </tr>
                <tr>
                  <td style={{ padding: "4px 8px", fontWeight: 700 }}>Name</td>
                  <td style={{ padding: "4px 8px" }}>{summary.name}</td>
                </tr>
                <tr>
                  <td style={{ padding: "4px 8px", fontWeight: 700 }}>Course</td>
                  <td style={{ padding: "4px 8px" }}>
                    {summary.course}
                    {summary.semester ? ` (Sem ${summary.semester})` : ""}
                  </td>
                </tr>
              </tbody>
            </table>
            <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 12 }}>
              <tbody>
                {(summary.sub_items || []).map((it, i) => (
                  <tr key={i}>
                    <td style={{ padding: "4px 8px", borderBottom: "1px solid #eee" }}>{it.sm_head}</td>
                    <td style={{ padding: "4px 8px", textAlign: "right", borderBottom: "1px solid #eee" }}>
                      &#8377; {it.sm_amount}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td style={{ padding: "4px 8px", fontWeight: 700 }}>Total Paid</td>
                  <td style={{ padding: "4px 8px", textAlign: "right", fontWeight: 700 }}>
                    &#8377; {summary.amount}
                  </td>
                </tr>
              </tbody>
            </table>
            <Button variant="contained" color="primary" onClick={() => window.print()}>
              Print Receipt
            </Button>
          </div>
        )}
      </Container>
    </div>
  );
}
